import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ToothConfigurationModel} from '../../../../../../models/teeth/tooth-configuration.model';
import {EndoMultiToothExamDataModel} from '../../../../../../models/forms/custom/mti/endo-multi-tooth-exam-data.model';
import {TdoTableV2Component} from '../../../../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {MtiPriorExamModel} from './models/mti-prior-exam.model';
import {TdoTableSelectionEvent} from '../../../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';

@Component({
  selector: 'app-mti-prior-exam-tooth-dialog',
  templateUrl: './mti-prior-exam-tooth-dialog.component.html',
  styleUrls: ['./mti-prior-exam-tooth-dialog.component.scss']
})
export class MtiPriorExamToothDialogComponent implements OnInit {
  @ViewChild('table') table: TdoTableV2Component;

  cfgTeeth: ToothConfigurationModel[] = [];
  exams: EndoMultiToothExamDataModel[] = [];
  dataSource: MtiPriorExamModel[] = [];
  selected: MtiPriorExamModel[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<MtiPriorExamToothDialogComponent>) {
    this.exams = data.exams as EndoMultiToothExamDataModel[];
    this.cfgTeeth = data.cfgTeeth as ToothConfigurationModel[];

    for (const exam of this.exams) {
      for (const tooth of exam.dataEndoMutiToothExamTeethinExams) {
        const model = new MtiPriorExamModel();
        model.exam = exam;
        model.tooth = tooth.dataEndoMutiToothExamTooth;
        this.dataSource.push(model);
      }
    }
  }

  ngOnInit(): void {
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onOkClick() {
    this.dialogRef.close(this.selected);
  }

  getDate(dateString: string) {
    return new Date(dateString).toLocaleDateString();
  }

  getTooth(ToothId: string) {
    const tooth = this.cfgTeeth.find(p => p.ToothId.toLowerCase() === ToothId.toLowerCase());
    if (tooth) {
      return tooth.cfgToothDescriptions[0].Notation;
    } else {
      return '';
    }
  }

  onRowSelected(event: TdoTableSelectionEvent) {
    event.row.model.isSelected = true;
    if (!this.selected.includes(event.row.model)) {
      event.row.model.isChecked = true;
      this.selected.push(event.row.model);
    } else {
      const idx = this.selected.findIndex(p => p === event.row.model);
      if (idx > -1) {
        event.row.model.isChecked = false;
        this.selected.splice(idx, 1);
      }
    }
  }
}
